// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host-context(html.dark-mode) a.mp-button-container.mp-button-templates-event .mp-button-content{color:var(--blue3)}a.mp-button-container.mp-button-templates-event .mp-button-content{color:var(--blue1)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
